import React from 'react';
import Icon from '../Icon';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { ProductListingType } from '../../constants';
import { setProductListingType } from '../../Actions/ProductListing.action';
import { translate } from '../../Services/translation';

const LayoutSwitch = () => {
  const dispatch = useDispatch();
  const { productListingType } = useSelector((state) => state.productListing);

  const isCurrentListing = (type) => {
    return type === productListingType;
  };

  return (
    <div className="layout-switch">
      {Object.entries(ProductListingType).map(([key, value]) => (
        <button
          className={clsx(
            'layout-switch__button',
            isCurrentListing(value) ? 'layout-switch__button--current' : ''
          )}
          key={key}
          onClick={() => dispatch(setProductListingType(value))}
        >
          <Icon
            name={key + (isCurrentListing(value) ? '-Filled' : '')}
            size={24}
            className={clsx(
              'layout-switch__icon',
              isCurrentListing(value) ? 'layout-switch__icon--current' : ''
            )}
          />
          {translate('product.layout.' + value.toLocaleLowerCase())}
        </button>
      ))}
    </div>
  );
};

export default LayoutSwitch;
